module.exports = __webpack_public_path__ + "static/media/ARROZCACHA_MENU-normal.92941f40.png";